import React from 'react';

import { useCopyName } from 'scenes/Gallery/ConversionPages/hooks';

import Actions from './Actions';

const ConversionPageActions = ({ limit, onEdit, data, color }) => {
  const copyName = useCopyName();

  const handleCopyName = () => copyName(data?.name);

  const handleOpen = () => {
    window.open(data?.url, '_blank');
  };

  const handleEdit = () => {
    onEdit(data);
  };

  return (
    <Actions
      limit={limit}
      color={color}
      onCopyName={handleCopyName}
      onEdit={handleEdit}
      onOpen={handleOpen}
    />
  );
};

export default ConversionPageActions;
